import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Indexs from './Indexs.js';
//import { AuthProvider } from './contexts/AuthContext';
import Auth2 from './Auth2.js';
import { ConvexProvider } from "convex/react";
import { client } from "./convexClients.js";
import MFASetup from './MFASETUP2.js';
import MFAVerify from './MFAVERIFY.js';
import ProgressForm from './ProgressForm.js';
import Suggestions from './Suggestions.js';
import ActivityPage from './ActivityPage.js';
import PhysicalHealthPage from './PhysicalHealthPage.js';
import MentalEmotionalPage from './MentalEmotionalPage.js';
import LearningGrowthPage from './LearningGrowthPage.js';
import ProductivityCareerPage from './ProductivityCareerPage.js';
import FinancialPage from './FinancialPage.js';
import PersonalLifestylePage from './PersonalLifestyle.js';
import SocialRelationshipsPage from './SocialRelationsPage.js';
import LeaderboardPage from './LeaderBoardPage.js';
import WeeklyChallengesPage from './WeeklyChallengePage.js';
import BadgesPage from './BadgePage.js';
import PricingPage from './PricingPage.js';
import FreeVersion from './FreeVersion.js';
import FreeVersionSuggestions from './FreeVersionSuggestions.js';
//import ScriptGenerator2 from './ScriptGenerator3.js';
//import PricingPage from './PricingPage.js';
//import ProtectedRoute from './ProtectedRoute';

//import 
function App() {

  return (
    <div>
      <ConvexProvider client={client}>
    <Router>
        <Routes>
        <Route path="/" element={<Indexs />} />   
        <Route path="/auth" element={<Auth2 />} />  
        <Route path="/mfa-setup" element={<MFASetup />} />
        <Route path="/mfa-verify" element={<MFAVerify />} />
        <Route path="/pricingpage" element={<PricingPage />} /> 

        <Route path="/freeversion" element={<FreeVersion />} /> 
        <Route path="/suggestionsfree" element={<FreeVersionSuggestions />} /> 


        <Route path="/progressform" element={<ProgressForm />} />
        <Route path="/suggestions" element={<Suggestions />} />
        <Route
          path="/activity/:suggestionId/:userId"
          element={<ActivityPage />}
        />
        <Route
          path="/physical-health/:progressId/:userId"
          element={<PhysicalHealthPage />}
        />

        <Route
          path="/mental-emotional/:progressId/:userId"
          element={<MentalEmotionalPage />}
        />

        <Route
          path="/learning-growth/:progressId/:userId"
          element={<LearningGrowthPage />}
        />

        <Route
          path="/productivity-career/:progressId/:userId"
          element={<ProductivityCareerPage />}
        />

        <Route
        path="/financial/:progressId/:userId"
        element={<FinancialPage />}
      />

      <Route
        path="/personal-lifestyle/:progressId/:userId"
        element={<PersonalLifestylePage />}
      />
      <Route
        path="/social-relationships/:progressId/:userId"
        element={<SocialRelationshipsPage />}
      />

  

<Route
  path="/leaderboard/:userId"
  element={<LeaderboardPage />}
/>

<Route
  path="/weeklychallenge/:userId"
  element={<WeeklyChallengesPage />}
/>
<Route
  path="/badges/:userId"
  element={<BadgesPage/>}
/>


        </Routes>
    </Router>
    </ConvexProvider>
  </div>
  );
}

export default App;
